<template>
  <div id="all-events-list" class="jci-preview-modal">
    <v-overlay :value="ProgressFlag" z-index="999">
      <v-progress-circular indeterminate size="64" color="#0097D7" width="5"></v-progress-circular>
    </v-overlay>

    <div class="d-flex justify-content-center my-3" v-if="LoadingFlag">
      <b-spinner variant="primary" type="grow" label="Loading..." style="color: #3A67B1 !important;"></b-spinner>
    </div>

    <!-- Top Multi-Color Brand Accent Ribbon -->
    <div class="jci-modal-accent-strip"></div>

    <!-- Header Bar -->
    <div class="jci-modal-header px-6 py-4 d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <div class="jci-header-icon-pill mr-3">
          <v-icon color="#FFFFFF" small>mdi-file-document</v-icon>
        </div>
        <div>
          <h2 class="jci-modal-title mb-0">{{ PageTitle }}</h2>
        </div>
      </div>
      <v-btn icon dark @click="closePrompt" class="jci-close-icon-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card flat class="jci-preview-card">
      <v-card-text class="pa-6">
        <v-container class="py-0">
          <!-- Member Profile Header Hero Card -->
          <div class="jci-profile-hero-card pa-4 mb-5 d-flex flex-column flex-sm-row align-center">
            <div class="jci-avatar-wrapper mr-sm-5 mb-3 mb-sm-0">
              <img width="80" height="80" class="rounded-circle jci-avatar-img" :src="row.ProfilePic" />
            </div>
            <div class="text-center text-sm-left flex-grow-1">
              <h3 class="jci-member-name mb-1">{{ row.MemberNameTxt || 'Member Name' }}</h3>
              <div class="d-flex flex-wrap align-center justify-center justify-sm-start gap-2 mt-2">
                <span class="jci-badge jci-badge-navy" v-if="row.MembershipId">
                  <v-icon left x-small color="#FFFFFF">mdi-card-account-details</v-icon>
                  ID: {{ row.MembershipId }}
                </span>
                <span class="jci-badge jci-badge-aqua" v-if="row.ZoneName || row.LomName">
                  <v-icon left x-small color="#FFFFFF">mdi-map-marker</v-icon>
                  {{ row.ZoneName }} - {{ row.LomName }}
                </span>
                <span class="jci-badge jci-badge-seafoam" v-if="row.MemberTypeName">
                  <v-icon left x-small color="#FFFFFF">mdi-account</v-icon>
                  {{ row.MemberTypeName }}
                </span>
              </div>
            </div>
          </div>

          <!-- 2-Column Split Executive Voucher Layout -->
          <v-row wrap class="mt-0">
            <!-- Left Column: Member Details -->
            <v-col cols="12" md="6" class="py-2">
              <div class="jci-detail-card h-100">
                <div class="jci-detail-card-header d-flex align-center px-4 py-3">
                  <v-icon color="#3A67B1" small class="mr-2">mdi-account-card-details</v-icon>
                  <h4 class="jci-card-title mb-0">Member Details</h4>
                </div>
                <div class="jci-detail-card-body pa-3">
                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Member Type</span>
                    <span class="jci-kv-value">{{ row.MemberTypeName || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Mobile No</span>
                    <span class="jci-kv-value">{{ row.MobileNo || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Email Id</span>
                    <span class="jci-kv-value text-truncate ml-2" style="max-width: 220px;" :title="row.EmailId">{{ row.EmailId || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Aadhar Number</span>
                    <span class="jci-kv-value">{{ row.AadharNumber || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> PAN Number</span>
                    <span class="jci-kv-value">{{ row.GstNumber || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Income Tax Claim</span>
                    <span class="jci-kv-value">
                      <v-chip
                        x-small
                        :color="row.ClaimTax == 1 ? '#56BDA3' : '#718096'"
                        dark
                        class="font-weight-medium px-2"
                      >
                        {{ row.ClaimTaxTxt || 'No' }}
                      </v-chip>
                    </span>
                  </div>

                  <div class="mt-3 text-center pa-2" v-if="row.ClaimTax == 1">
                    <span class="jci-kv-label d-block mb-2">PanCard Image</span>
                    <img width="130" height="85" class="rounded jci-pan-img" :src="row.PanImagePath" />
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Right Column: Title Payment Details -->
            <v-col cols="12" md="6" class="py-2">
              <div class="jci-detail-card h-100">
                <div class="jci-detail-card-header d-flex align-center px-4 py-3">
                  <v-icon color="#3A67B1" small class="mr-2">mdi-credit-card</v-icon>
                  <h4 class="jci-card-title mb-0">Title Payment Details</h4>
                </div>
                <div class="jci-detail-card-body pa-3">
                  <!-- Featured Hero Amount Banner -->
                  <div class="jci-hero-amount-banner pa-3 mb-3 text-center rounded-lg">
                    <span class="jci-hero-amount-label">AMOUNT PAID</span>
                    <div class="jci-hero-amount-val">₹ {{ row.OrderAmount || '0' }}</div>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Title Name</span>
                    <span class="jci-kv-value font-weight-bold" style="color: #3A67B1;">{{ row.TitleName || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Paid Date</span>
                    <span class="jci-kv-value">{{ row.PaidDate || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Register No</span>
                    <span class="jci-kv-value jci-code-badge">{{ row.RegisterNo || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Payment Method</span>
                    <span class="jci-kv-value text-capitalize">{{ row.PaymentMethod || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Transaction Type</span>
                    <span class="jci-kv-value">{{ row.TypeTxt || '-' }}</span>
                  </div>

                  <div class="jci-kv-row d-flex align-center justify-space-between px-3 py-2 rounded">
                    <span class="jci-kv-label"><span class="jci-bullet-dot"></span> Razorpay ID</span>
                    <span class="jci-kv-value jci-code-badge text-truncate ml-2" style="max-width: 180px;" :title="row.PaymentId">{{ row.PaymentId || '-' }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>
        <v-btn class="jci-modal-close-btn" @click="closePrompt">
          <v-icon left small>mdi-close</v-icon>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      type: Boolean,
      required: true
    },
    recordData: {
      required: true
    },
    PageTitle: {
      required: true
    }
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ProgressFlag: false,
      TableLoadingFlag: false,

      row: {},

      CurrentYearId: 0,
      JciYearCode: "",
      YearName: ""
    };
  },
  mounted() {},
  watch: {},
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");

      console.log("recordData=" + JSON.stringify(this.recordData));
      this.row = this.recordData;
    }
  },
  beforeMount() {
    this.refreshPageData();
  }
};
</script>
<style lang="scss">
/* Ultra-Rich Executive JCI Statement Preview */

#all-events-list.jci-preview-modal {
  color: #414042;
  font-family: inherit;

  .jci-modal-accent-strip {
    height: 4px;
    background: linear-gradient(90deg, #EDBE38 0%, #56BDA3 35%, #0097D7 70%, #3A67B1 100%);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  .jci-modal-header {
    background: linear-gradient(135deg, #0A0F29 0%, #3A67B1 60%, #0097D7 100%);
    color: #ffffff;
    box-shadow: 0 4px 15px rgba(10, 15, 41, 0.15);
  }

  .jci-header-icon-pill {
    width: 38px;
    height: 38px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(4px);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
  }

  .jci-modal-title {
    font-size: 1.3rem;
    font-weight: 800;
    color: #ffffff;
    letter-spacing: -0.01em;
  }

  .jci-close-icon-btn {
    opacity: 0.88;
    transition: opacity 0.2s, transform 0.2s;
    &:hover {
      opacity: 1;
      transform: rotate(90deg);
    }
  }

  .jci-preview-card {
    border-bottom-left-radius: 16px !important;
    border-bottom-right-radius: 16px !important;
    background: #ffffff;
  }

  .jci-profile-hero-card {
    background: linear-gradient(135deg, #ffffff 0%, rgba(58, 103, 177, 0.05) 100%);
    border: 1px solid rgba(58, 103, 177, 0.15);
    border-left: 4px solid #3A67B1;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(10, 15, 41, 0.03);
  }

  .jci-avatar-img {
    object-fit: cover;
    border: 3px solid #0097D7;
    outline: 3px solid rgba(0, 151, 215, 0.2);
    box-shadow: 0 4px 14px rgba(0, 151, 215, 0.25);
  }

  .jci-member-name {
    font-size: 1.3rem;
    font-weight: 800;
    color: #0A0F29;
  }

  .gap-2 {
    gap: 8px;
  }

  .jci-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.775rem;
    font-weight: 700;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);

    &.jci-badge-navy {
      background-color: #3A67B1;
      color: #ffffff;
    }

    &.jci-badge-aqua {
      background-color: #0097D7;
      color: #ffffff;
    }

    &.jci-badge-seafoam {
      background-color: #56BDA3;
      color: #ffffff;
    }
  }

  .jci-detail-card {
    background: #ffffff;
    border: 1px solid #E2E8F0;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(10, 15, 41, 0.02);
  }

  .jci-detail-card-header {
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.07) 0%, rgba(0, 151, 215, 0.04) 100%);
    border-bottom: 1px solid rgba(58, 103, 177, 0.12);
  }

  .jci-card-title {
    font-size: 0.95rem;
    font-weight: 800;
    color: #3A67B1;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .jci-kv-row {
    transition: background-color 0.15s ease;

    &:nth-child(even) {
      background-color: #F8FAFC;
    }

    &:hover {
      background-color: rgba(58, 103, 177, 0.04) !important;
    }
  }

  .jci-bullet-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #0097D7;
    border-radius: 50%;
    margin-right: 8px;
  }

  .jci-kv-label {
    font-size: 0.825rem;
    font-weight: 600;
    color: #414042;
  }

  .jci-kv-value {
    font-size: 0.9rem;
    font-weight: 700;
    color: #0A0F29;
  }

  .jci-code-badge {
    font-family: monospace;
    font-size: 0.85rem;
    background: rgba(58, 103, 177, 0.09);
    color: #3A67B1;
    padding: 3px 10px;
    border-radius: 6px;
    font-weight: 700;
    border: 1px solid rgba(58, 103, 177, 0.18);
  }

  .jci-hero-amount-banner {
    background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%);
    color: #ffffff;
    box-shadow: 0 6px 20px rgba(0, 151, 215, 0.35);
  }

  .jci-hero-amount-label {
    font-size: 0.75rem;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.85);
    letter-spacing: 1px;
    display: block;
  }

  .jci-hero-amount-val {
    font-size: 1.6rem;
    font-weight: 900;
    color: #ffffff;
    letter-spacing: -0.02em;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }

  .jci-pan-img {
    object-fit: cover;
    border: 2px solid #E2E8F0;
    box-shadow: 0 3px 8px rgba(0,0,0,0.08);
  }

  .jci-modal-close-btn {
    background: linear-gradient(135deg, #3A67B1 0%, #0097D7 100%) !important;
    color: #ffffff !important;
    font-weight: 700 !important;
    border-radius: 10px !important;
    padding: 0 32px !important;
    height: 42px !important;
    text-transform: none !important;
    box-shadow: 0 6px 18px rgba(58, 103, 177, 0.3) !important;
    transition: all 0.25s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 151, 215, 0.45) !important;
    }
  }
}
</style>